import * as ko from 'knockout';
import fetch from 'node-fetch';

import { LogoutResponse, User, AuthState } from '../contracts';
import template from './User.html';
import { ViewId } from '../configuration';

class Home {

  user: ko.Observable<string> = ko.observable<string>("");
  userMessage: ko.Observable<string> = ko.observable<string>("");
  infoLinkText: ko.Observable<string> = ko.observable<string>("");
  infoLinkUri: ko.Observable<string> = ko.observable<string>("");
  logoutButton: ko.Observable<string> = ko.observable<string>("");
  selectedLangage: ko.PureComputed<string> = ko.pureComputed(() => global.Logonme.SelectedLanguage());
  activateView: ko.PureComputed<boolean> = ko.pureComputed(() => global.Logonme.ActiveView() == ViewId.Home);

  constructor() {

    this.updateStrings(this.selectedLangage())
    this.selectedLangage.subscribe((lang: string) => {
      this.updateStrings(lang)
    })

    this.activateView.subscribe((activate: boolean) => {
      if (activate) {
        console.log("Home:activate");
        this.doGetCurrentUser();
      }
    });
  }

  private updateStrings(lang: string) {
    this.userMessage(global.Logonme.LocalizationManager.getText('logged-in-user-message', lang));
    this.logoutButton(global.Logonme.LocalizationManager.getText("logout-button", lang));
    this.infoLinkText(global.Logonme.LocalizationManager.getText('logged-in-info-link-text', lang));
    this.infoLinkUri(global.Logonme.LocalizationManager.getText('logged-in-info-link-uri', lang));
  }

  private async getCurrentUser(): Promise<User> {
    var uri = `${global.Logonme.Configuration.baseUrl}/ls/${global.Logonme.Configuration.tenant}/whoami`;
    var response = await fetch(uri);
    var userResponse = await response.json<User>();
    return userResponse;
  }

  private async logout(): Promise<LogoutResponse> {
    var uri = `${global.Logonme.Configuration.baseUrl}/ls/${global.Logonme.Configuration.tenant}/forms/logout`;
    var response = await fetch(uri);
    var logoutResponse = await response.json<LogoutResponse>();
    return logoutResponse;
  }

  async doLogout() {
    await this.logout().then((response: LogoutResponse) => {
      global.Logonme.AuthState(response.authState);
      global.Logonme.SelectedMethod(null);
    });
  }

  async doGetCurrentUser() {
    console.log("doGetCurrentUser")
    await this.getCurrentUser().then((user: User) => {

      var name = user.displayName ?? (user.username ?? (user.emailAddress ?? user.mobilePhone));
      var altName = user.emailAddress ?? (user.mobilePhone ?? user.userId);
      altName = '(' + altName + ')';
      var loggedInUser = name + altName;
      this.user(loggedInUser);
    }, (reason: any) => {
      alert(`getUser failed => ${reason}`);
    });
  }

}

export default { viewModel: Home, template: template };
